import { render } from "./SearchCriteria.vue?vue&type=template&id=61748d05&scoped=true"
import script from "./SearchCriteria.vue?vue&type=script&lang=js"
export * from "./SearchCriteria.vue?vue&type=script&lang=js"

import "./SearchCriteria.vue?vue&type=style&index=0&id=61748d05&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61748d05"]])

export default __exports__